import { apiClient } from 'model/axiosConfig'
import {typeCallbackDataItem} from "./settingsReducer";


// Get callback list
export const getCallbackList = async () => {

    const path = '/product/callback'
    const config = {
        headers: {},
    }

    try {
        return await apiClient.get(path, config)
    } catch (error) {
        return error
    }
}


// Add callback
export const addCallback = async (payload: { dataObject: typeCallbackDataItem}) => {

    const path = '/product/callback'
    const config = {
        headers: {},
    }
    const data = payload.dataObject

    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        return error
    }
}


// Delete callback item
export const deleteCallback = async (payload: { callbackId: string}) => {

    const path = '/product/callback/' + payload.callbackId
    const config = {
        headers: {},
    }

    try {
        return await apiClient.delete(path, config)
    } catch (error) {
        return error
    }
}




// Edit callback url
export const changeCallbackUrl = async (payload: { callbackId: string, callbackUrl: string}) => {

    const path = `/product/callback/${payload.callbackId}/url`
    const config = {
        headers: {},
    }
    const data = {url: payload.callbackUrl}
    //console.log('API', payload.callbackUrl)

    try {
        const response = await apiClient.patch(path, data, config)
        return response
    } catch (error) {
        return error
    }
}
